import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { KEY_CODES } from 'constants'
import { WINDOW_BOUNDS_OFFSET } from './constants'

import styles from './Popover.scss'


export class Popover extends React.Component {
    static propTypes = {
        place: PropTypes.string.isRequired,

        afterShow: PropTypes.func,
        afterHide: PropTypes.func,

        playHoverSound: PropTypes.func,
        playCancelClickSound: PropTypes.func,
    }
    static defaultProps = {
        place: 'top',
    }
    constructor(props) {
        super(props)
        this.target = null
        this.state = {
            opened: false,
            type: null,
        }
        this.onKeyDown = this.onKeyDown.bind(this)
        this.boundHide = this.hide.bind(this)
    }
    handleClick(e) {
        e.stopPropagation()
    }
    componentWillMount() {
        window.addEventListener('click', this.boundHide)
        window.addEventListener('keydown', this.onKeyDown)
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.boundHide)
        window.removeEventListener('keydown', this.onKeyDown)
    }

    componentDidUpdate() {
        if (!this.state.opened) return

        this.setPosition()
    }
    setPosition() {
        // Calculate position
        const targetPosition = this.target.getBoundingClientRect()
        const popoverNode = this.refs.base
        const arrowNode = this.refs.arrow

        // Calculate left position of the popover
        let popoverLeft = Math.round(targetPosition.left + targetPosition.width / 2 - popoverNode.clientWidth / 2)
        let arrowLeft = popoverNode.clientWidth / 2

        if (popoverLeft < 0) {
            popoverLeft = WINDOW_BOUNDS_OFFSET
            arrowLeft = targetPosition.left + targetPosition.width / 2 - popoverLeft
        } else if (popoverLeft + popoverNode.clientWidth > window.innerWidth) {
            popoverLeft = window.innerWidth - popoverNode.clientWidth - WINDOW_BOUNDS_OFFSET
            arrowLeft = targetPosition.left + targetPosition.width / 2 - popoverLeft
        }

        const popoverOffset = this.target.dataset.popoverOffset
        let offset = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        }
        if (popoverOffset) {
            offset = {
                offset,
                ...JSON.parse(popoverOffset),
            }
        }

        if (this.props.place === 'top') {
            const popoverBottom = window.innerHeight - targetPosition.top + offset.bottom
            popoverNode.style.bottom = `${popoverBottom}px`
        } else {
            const popoverTop = targetPosition.top - popoverNode.clientHeight
            popoverNode.style.top = `${popoverTop}px`
        }

        arrowNode.style.left = `${arrowLeft}px`
        popoverNode.style.left = `${popoverLeft}px`
    }
    show(target) {
        this.target = target
        this.setState({
            opened: true,
            type: this.target.dataset.popoverType,
        })
        if (this.props.afterShow) this.props.afterShow()
    }
    hide() {
        if (!this.state.opened) return
        this.setState({
            opened: false,
            type: null,
        })
        if (this.props.afterHide) this.props.afterHide()
    }
    toggle(target) {
        if (this.state.opened) {
            this.hide()
        } else {
            this.show(target)
        }
    }
    onKeyDown(e) {
        if (e.keyCode === KEY_CODES.ESCAPE) {
            this.hide()
        }
    }
    render() {
        const className = classNames(styles.base,
            styles[`base__place-${this.props.place}`],
            styles[`base__type-${this.state.type}`],
            {
                [styles.base__open]: this.state.opened,
            }
        )
        const handleClose = () => {
            this.props.playCancelClickSound()
            this.hide()
        }
        const handleHover = this.props.playHoverSound.bind(this)
        return (
            <div className={className} ref='base' onClick={this.handleClick}>
                <div className={styles.body}>
                    <div className={styles.wrapper}>
                        <div className={styles.background}></div>
                    </div>
                    <div className={styles.content}>
                        <div onClick={handleClose} onMouseEnter={handleHover} className={styles.cancel} />
                        {this.props.children}
                    </div>
                    <div className={styles.arrow} ref='arrow'></div>
                </div>
            </div>
        )
    }
}

export default Popover



// WEBPACK FOOTER //
// ./components/Popover/Popover.jsx